import {
  GET_DEPARTMENT,
  GET_DEPTSTRUCTURE,
  GET_DEPARTMENT_SUCCESS,
  GET_DEPARTMENT_FAIL,
  DELETE_DEPARTMENT,
  DELETE_DEPARTMENT_SUCCESS,
  DELETE_DEPARTMENT_FAIL,
  UPDATE_DEPARTMENT,
  UPDATE_DEPARTMENT_SUCCESS,
  UPDATE_DEPARTMENT_FAIL,
  ADD_NEW_DEPARTMENT,
  ADD_DEPARTMENT_SUCCESS,
  ADD_DEPARTMENT_FAIL,
  DEPARTMENT_LOADING,
  DEPARTMENT_RESET
} from "./actionType";

export const resetDepartmentState = (actionType) => ({
  type: DEPARTMENT_RESET,
  payload: { actionType },
});

export const getDepartmentSuccess = (actionType, data) => ({
  type: GET_DEPARTMENT_SUCCESS,
  payload: { actionType, data },
});

export const getDepartmentFail = (actionType, error) => ({
  type: GET_DEPARTMENT_FAIL,
  payload: { actionType, error },
});

export const getDepartment = (data, path) => ({
  type: GET_DEPARTMENT,
  payload: data, path
});

export const getDeptStructure = (data, path) => ({
  type: GET_DEPTSTRUCTURE,
  payload: data, path
});

export const getDepartmentLoading = () => ({
  type: DEPARTMENT_LOADING
});

export const deleteDepartment = data => ({
  type: DELETE_DEPARTMENT,
  payload: data,
});

export const deleteDepartmentSuccess = data => ({
  type: DELETE_DEPARTMENT_SUCCESS,
  payload: data,
});

export const deleteDepartmentFail = error => ({
  type: DELETE_DEPARTMENT_FAIL,
  payload: error,
});

export const updateDepartment = data => ({
  type: UPDATE_DEPARTMENT,
  payload: data,
});

export const updateDepartmentFail = error => ({
  type: UPDATE_DEPARTMENT_FAIL,
  payload: error,
});

export const updateDepartmentSuccess = data => ({
  type: UPDATE_DEPARTMENT_SUCCESS,
  payload: data,
});

export const addNewDepartment = data => ({
  type: ADD_NEW_DEPARTMENT,
  payload: data,
});

export const addDepartmentSuccess = data => ({
  type: ADD_DEPARTMENT_SUCCESS,
  payload: data,
});

export const addDepartmentFail = error => ({
  type: ADD_DEPARTMENT_FAIL,
  payload: error,
});